<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("helpdesk_settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("notification_settings") }}</h1>

        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_email_notifications"
            v-model="meta.send_email_notifications"
          />
          <label for="chk_email_notifications">
            {{ $t("send_email_notifications") }}
          </label>
        </div>

        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_sms_notifications"
            v-model="meta.send_sms_notifications"
          />
          <label for="chk_sms_notifications">
            {{ $t("send_sms_notifications") }}
          </label>
        </div>
      </div>

      <div class="column">
        <h1 class="title is-5">{{ $t("auto_assign_agents") }}</h1>

        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_auto_assign"
            v-model="meta.auto_assign_agents"
          />
          <label for="chk_auto_assign">
            {{ $t("auto_assign_agents") }}
          </label>
        </div>

        <div class="field" v-if="meta.auto_assign_agents">
          <generic-dropdown
            :title="$t('default_status')"
            :placeholder="$t('select_status')"
            :is_multiple="false"
            url="/helpdesk/status/catalog"
            name_field="name"
            value_field="status_id"
            @selected="set_default_status"
            ref="default_status_dropdown"
          />
        </div>

        <div class="field" v-if="meta.auto_assign_agents">
          <generic-dropdown
            :title="$t('default_priority')"
            :placeholder="$t('select_priority')"
            :is_multiple="false"
            url="/helpdesk/priority/catalog"
            name_field="name"
            value_field="priority_id"
            @selected="set_default_priority"
            ref="default_priority_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("auto_close_resolved") }}</h1>

        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_auto_close"
            v-model="meta.auto_close_resolved"
          />
          <label for="chk_auto_close">
            {{ $t("auto_close_resolved") }}
          </label>
        </div>

        <div class="field" v-if="meta.auto_close_resolved">
          <label class="label">{{ $t("close_after_days") }}</label>
          <input
            type="number"
            class="input"
            v-model="meta.close_after_days"
            min="1"
            max="30"
          />
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button
            class="button is-rounded is-primary"
            @click="save"
            :class="{ 'is-loading': saving }"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "HelpdeskSettings",
  components: { GenericDropdown },
  data() {
    return {
      saving: false,
      meta: {
        send_email_notifications: true,
        send_sms_notifications: false,
        auto_assign_agents: false,
        auto_close_resolved: false,
        close_after_days: 7,
        default_status_id: null,
        default_priority_id: null,
      },
    };
  },
  methods: {
    save() {
      let v = this;
      v.saving = true;

      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("configuration_saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.saving = false;
        });
    },
    set_default_status(status) {
      this.meta.default_status_id = status.status_id;
    },
    set_default_priority(priority) {
      this.meta.default_priority_id = priority.priority_id;
    },
  },
  created() {
    let v = this;
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = { ...v.meta, ...conf };

          // Establecer valores en dropdowns después del siguiente tick
          v.$nextTick(() => {
            if (conf.default_status_id && v.$refs.default_status_dropdown) {
              v.$refs.default_status_dropdown.set_value(conf.default_status_id);
            }
            if (conf.default_priority_id && v.$refs.default_priority_dropdown) {
              v.$refs.default_priority_dropdown.set_value(
                conf.default_priority_id
              );
            }
          });
        }
      })
      .catch((error) => {
        error_message(error);
      });
  },
};
</script>
